import React from 'react';
import { ScreenSizeDetector } from '../../../../../lib/helpers';
import { Col } from '../../../../grid';
import { Bold, Paragraph } from '../../../../typography';

const RenderCountPrColli = ({
  dontShowColli,
  countPrColli,
  countPrPalle,
  productTypePalle,
  packageNoun,
  productTypeFadoel,
  productTypePack,
}) => {
  if (dontShowColli) {
    return null;
  }
  // If countpercolli is 0 or below, we don't want to show it. Also if it's null. Also if it's nulag=nil.
  if (countPrColli <= 0 || countPrColli === null || countPrColli === 'nulag=nil' || productTypeFadoel || productTypePack) {
    return null;
  }
  if (productTypePalle) {
    return (
      <ScreenSizeDetector padding={[[1599, '5px 15px'], '15px']}>
        <Col xs={6} sm={3} md={3} lg={6} xl={6} xxl={3}>
          <Paragraph marginBottom="0">
            <Bold>Antal pr. {packageNoun.toLowerCase()}</Bold><br />
            {countPrColli} stk.
          </Paragraph>
        </Col>
        <Col xs={6} sm={3} md={3} lg={6} xl={6} xxl={3}>
          <Paragraph marginBottom="0">
            <Bold>Antal Kolli</Bold><br />
            {countPrPalle} stk.
          </Paragraph>
        </Col>
        <Col xs={6} sm={3} md={3} lg={6} xl={6} xxl={3}>
          <Paragraph marginBottom="0">
            <Bold>Antal pr. palle</Bold><br />
            {countPrColli * countPrPalle} stk.
          </Paragraph>
        </Col>
      </ScreenSizeDetector>
    );
  }
  return (
    <ScreenSizeDetector padding={[[1599, '5px 15px'], '15px']}>
      <Col xs={6} sm={3} md={3} lg={6} xl={6} xxl={3}>
        <Paragraph marginBottom="0">
          <Bold>Antal</Bold><br />
          {countPrColli} stk.
        </Paragraph>
      </Col>
    </ScreenSizeDetector>
  );
};

export default RenderCountPrColli;
